export class ListenerManager<L> {
	private listeners: L[] = [];

	addListener = (listener: L) => {
		if (this.listeners.indexOf(listener) === -1) {
			this.listeners.push(listener);
			return true;
		}
		return false;
	};

	getCount() {
		return this.listeners.length;
	}

	removeListener = (listener: L) => {
		const index = this.listeners.indexOf(listener);
		if (index !== -1) {
			const result = this.listeners.splice(index, 1);
			return !!result;
		}
		return false;
	};

	safeLoop(callback: (listener: L) => void) {
		const listenerClone = [...this.listeners];
		listenerClone.forEach((listener: L) => {
			try {
				callback(listener);
			} catch (err) {
				console.error(err);
			}
		});
	}

	clear() {
		// TODO - should they be removed first?
		this.listeners = [];
	}
}
